import * as Utility from './utility'
import * as Swal from './swal'
import Vue from 'vue'

export default {
	Computations: [{value: "PREPAID", label: "Prepaid"},
		{value: "REG_DIM", label: "Reg Dim"},
		{value: "FLAT", label: "Flat"},
		{value: "EQUATED", label: "Equated"}],
	Swal,
	Utility,
	fetchFile(url) {
		return Vue.http.post('/file', {url: url}, {responseType: 'blob'})
	}
}